"use client";

import { TabsList, TabsTrigger } from "@/components/ui/tabs";
import type { Category } from "@/components/ProductCardListWrapper/variants/ProductCardListBySearchTab/types";
import { createSearchTabValue } from "@/components/ProductCardListWrapper/variants/ProductCardListBySearchTab/utils/createSearchTabValue";
import { cn } from "@/lib/utils";

type CategoryTabBarProps = {
  categories: Category[];
  location?: string;
};

export function CategoryTabBar({ categories, location }: CategoryTabBarProps) {
  return (
    <div className="rounded-[0.625rem] bg-white">
      <TabsList className="overflow-x-scroll h-auto w-auto max-w-full justify-start bg-white">
        {categories.map((category) => {
          const sanitizedValue = createSearchTabValue(
            category.categoryLabel,
            location,
          );
          return (
            <TabsTrigger
              key={category.categoryLabel}
              value={sanitizedValue}
              className={cn(
                "grow-0 no-underline bg-transparent px-5 py-4",
                "text-md text-neutral-700 lg:text-base",
                "hover:text-primary",
                "data-[state=active]:bg-primary-500 data-[state=active]:font-bold",
                "first:rounded-l-[0.625rem] last:rounded-r-[0.625rem]",
              )}
            >
              {category.categoryLabel}
            </TabsTrigger>
          );
        })}
      </TabsList>
    </div>
  );
}
